import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = {
  key: 1,
  style: {"color":"green"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_5 = {
  key: 3,
  style: {"color":"green"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "d-flex align-center primary--text" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AccountingPeriodsSuiteErrors = _resolveComponent("AccountingPeriodsSuiteErrors")!
  const _component_AccountingPeriodsMissingLaps = _resolveComponent("AccountingPeriodsMissingLaps")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_AccountingPeriodIsDeletable = _resolveComponent("AccountingPeriodIsDeletable")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AccountingPeriod = _resolveComponent("AccountingPeriod")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "my-3 justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                onClick: _ctx.addAccountingPeriod,
                id: "AddAccountingPeriodAccountingPeriods",
                disabled: !_ctx.isAuthorized,
                "data-cy": "AccountingPeriods-add"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "10",
            class: "pl-2"
          })
        ]),
        _: 1
      }),
      (_ctx.accountingPeriodsSuiteErrors && _ctx.accountingPeriodsSuiteErrors.length)
        ? (_openBlock(), _createBlock(_component_AccountingPeriodsSuiteErrors, {
            key: 0,
            accountingPeriodsSuiteErrors: _ctx.accountingPeriodsSuiteErrors
          }, null, 8, ["accountingPeriodsSuiteErrors"]))
        : _createCommentVNode("", true),
      (_ctx.missingAccountingPeriodLaps && _ctx.missingAccountingPeriodLaps.length)
        ? (_openBlock(), _createBlock(_component_AccountingPeriodsMissingLaps, {
            key: 1,
            missingAccountingPeriodLaps: _ctx.missingAccountingPeriodLaps
          }, null, 8, ["missingAccountingPeriodLaps"]))
        : _createCommentVNode("", true),
      (_ctx.displayAccountingPeriods && _ctx.displayAccountingPeriods.length)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 2,
            "no-gutters": "",
            class: "d-flex justify-center",
            style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayAccountingPeriods, (ap) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '8',
                  class: "pa-2",
                  key: ap.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "default_card ma-0",
                      elevation: "0",
                      "pa-0": "",
                      style: {"margin":"5px"},
                      onClick: ($event: any) => (_ctx.openAccountingPeriod(ap))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "d-flex align-center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.$vuetify.display.mobile)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "1",
                                  class: "d-flex justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "secondary",
                                      class: "icon",
                                      size: "x-large"
                                    }, {
                                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode(" $date_range ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }),
                            _createVNode(_component_v_col, {
                              cols: _ctx.$vuetify.display.mobile ? '8' : '7'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex align-center justify-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                          style: {"font-weight":"bold","font-size":"16pt"}
                                        }, _toDisplayString(_ctx.formatDate(ap.start)) + " - " + _toDisplayString(_ctx.formatDate(ap.end)), 3)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex align-center justify-start"
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                            ap.manualCarryForwards && ap.manualCarryForwards.length
                                        )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (ap.carryForwardCount)
                                                ? (_openBlock(), _createElementBlock("strong", _hoisted_1, " Doublon avec le Report à de nouveau de bobbee"))
                                                : (_openBlock(), _createElementBlock("strong", _hoisted_2, "Report à nouveau manuel présent"))
                                            ], 64))
                                          : (!ap.carryForwardCount)
                                            ? (_openBlock(), _createElementBlock("strong", _hoisted_3, "Report à nouveau manquant"))
                                            : (_ctx.autoCarryForwardToDelete(ap))
                                              ? (_openBlock(), _createElementBlock("strong", _hoisted_4, "Report à nouveau bobbee présent à supprimer"))
                                              : (_openBlock(), _createElementBlock("strong", _hoisted_5, "Report à nouveau bobbee présent"))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["cols"]),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                (ap.closed)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "x-large",
                                      class: "px-1"
                                    }, {
                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode("$lock_outline")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isAuthorized)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (ap.isDeletable && ap.isDeletable.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                              activator: _withCtx(({ props }) => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_v_btn_trash, _mergeProps({
                                                    disabled: "",
                                                    ref_for: true
                                                  }, props), null, 16)
                                                ])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, [
                                                  _createVNode(_component_AccountingPeriodIsDeletable, {
                                                    isDeletable: ap.isDeletable
                                                  }, null, 8, ["isDeletable"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        : (_openBlock(), _createBlock(_component_v_btn_trash, {
                                            key: 1,
                                            onClick: _withModifiers(($event: any) => (_ctx.openDeleteAccountingPeriodDialog(ap)), ["stop"]),
                                            "data-cy": 'AccountingPeriods-trash-' + ap.id
                                          }, null, 8, ["onClick", "data-cy"]))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$edit",
                                  color: "secondary",
                                  "data-cy": 'AccountingPeriods-edit-' + ap.id
                                }, null, 8, ["data-cy"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["style"]))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 3,
            "no-gutters": "",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '8',
                class: "my-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card ma-0",
                    elevation: "0",
                    "pa-0": "",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        class: "d-flex align-center",
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "py-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "new_red",
                                    class: "icon",
                                    size: "x-large"
                                  }, {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                      _createTextVNode(" $date_range ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '10' : '8'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                  style: {"font-weight":"bold","font-size":"16pt"}
                                }, " Aucun exercice comptable ", 2)
                              ]),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                                }, " Vous n'avez enregistré aucun exercice comptable ", 2)
                              ])
                            ]),
                            _: 1
                          }, 8, ["cols"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })),
      (_ctx.accountingPeriodDialog)
        ? (_openBlock(), _createBlock(_component_AccountingPeriod, {
            key: 4,
            modelValue: _ctx.accountingPeriodDialog,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingPeriodDialog) = $event)),
            id: _ctx.selectedAccountingPeriodId,
            accountingPeriod: _ctx.selectedAccountingPeriod,
            accountingPeriods: _ctx.ligthAccountingPeriods,
            carryForwardDiagnostic: _ctx.selectedCarryForwardDiagnostic,
            prevAccountingPeriod: _ctx.getPrevAccountingPeriod(_ctx.selectedCarryForwardDiagnostic),
            companyId: _ctx.companyId,
            missingAccountingPeriodLaps: _ctx.missingAccountingPeriodLaps,
            accountingPeriodsSuiteErrors: _ctx.accountingPeriodsSuiteErrors,
            onUpsert: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh(false)))
          }, null, 8, ["modelValue", "id", "accountingPeriod", "accountingPeriods", "carryForwardDiagnostic", "prevAccountingPeriod", "companyId", "missingAccountingPeriodLaps", "accountingPeriodsSuiteErrors"]))
        : _createCommentVNode("", true),
      (_ctx.selectedAccountingPeriod)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 5,
            modelValue: _ctx.deleteAccountingPeriodDialog,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteAccountingPeriodDialog) = $event)),
            title: 'Suppression de l\'exercice',
            error: true,
            validTitle: `Supprimer l\'exercice du ${_ctx.formatDate(
                _ctx.selectedAccountingPeriod.start,
            )} au ${_ctx.formatDate(_ctx.selectedAccountingPeriod.end)}`,
            onValid: _ctx.deleteAccountingPeriod,
            validLoading: _ctx.deleteAccountingPeriodLoading,
            prefixDataCy: "ossFilterBar-delete",
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", _hoisted_9, " Êtes-vous sûr(e) de vouloir supprimer l'exercice du " + _toDisplayString(_ctx.formatDate(_ctx.selectedAccountingPeriod.start)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.selectedAccountingPeriod.end)) + " ? ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "validTitle", "onValid", "validLoading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}